import { RefObject } from 'react';
import { CURRENCY_ON_RIGHT } from '../constants';

export const scrollToRef = (ref: RefObject<HTMLElement>) =>
  window.scrollTo({ left: 0, top: ref.current?.offsetTop, behavior: 'smooth' });

export const getQueryParam = () => new URLSearchParams(window.location.search);

export const navigateToUrl = (url: string) => (window.location.href = url);

export const openNewTab = (url: string) => window.open(url);

export const getTime = () => new Date().getTime();

export const getLocal = () => window.__LOCALE__;

export const isLocalCyrillic = () => ['ru'].includes(getLocal());

export const isLocalJapanese = () => ['ja'].includes(getLocal());

export const getThanks = () => (window as any).__thanks__;

export const getUserData = () => {
  try {
    return window.__data__;
  } catch {
    return null;
  }
};

export const scrollToTop = () =>
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'auto',
  });

export const isLocalCurrencyOnRight = () =>
  CURRENCY_ON_RIGHT.includes(getLocal());

export const isMobileDevice = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );

export const currentOrigin = () => window.location.origin;

export const currentPathname = () => window.location.pathname;

export const mobileSendMessageToApp = {
  init: (totalPages: number = 3) => {
    sendMessageToRNApp({ type: 'INIT', totalPages });
  },
  startPage: (currentPage: number) => {
    sendMessageToRNApp({ type: 'UPDATE_CURRENT_PAGE', currentPage });
  },
  successPage: () => {
    sendMessageToRNApp({ type: 'ON_DONE', status: 'SUCCESS' });
  },
};

export const sendMessageToRNApp = (req: any) => {
  // @ts-expect-error
  const sendMessageToRNAppFn = window.sendMessageToRNApp;
  if (sendMessageToRNAppFn) {
    sendMessageToRNAppFn(req);
  }
};

export const refreshPage = () => {
  window.location.reload();
};

export const removeDrilldownParams = () => {
  const urlParams = getQueryParam();
  if (urlParams.get('cycleId') && urlParams.get('productId')) {
    const curUrl = window.location.href;
    let splitUrl = curUrl.split('&');
    splitUrl = splitUrl.slice(0, splitUrl.length - 2);
    history.pushState({}, '', splitUrl.join('&'));
  }
};

export const getOrigin = () => {
  const params = getQueryParam();
  return params.get('originAppSlug');
};

export const isEntry = {
  forms: () => getOrigin() === 'wix-forms',
  automations: () => getOrigin() === 'automations',
  emailMarketing: () => getOrigin() === 'email-marketing-1',
  chat: () => {
    const origin = getOrigin();
    return origin === 'editor' || origin === 'wix-chat' || origin === 'inbox';
  },
  socialPosts: () => getOrigin() === 'social-posts',
  videoMaker: () => getOrigin() === 'video-maker',
};
